import z from 'zod';
import { version } from '../../package.json';

const nodeEnvSchema = z.enum(['development', 'production', 'test']);
const appEnvSchema = z.enum(['development', 'stage', 'production']);

const envSchema = z.object({
  VITE_APP_ENV: appEnvSchema.default('development'),
  VITE_APP_TITLE: z.string(),
  VITE_APP_FETCH_TIMEOUT: z.string(),
  NODE_ENV: nodeEnvSchema.default('development'),
  VITE_APP_VERSION_INFO_FILENAME: z.string().default('version-info.txt'),
});
const envConfig = envSchema.parse(import.meta.env);

// Get BASE_URL from public/config.js
const rawBaseUrl = window.BASE_URL;
const pageSize = window.PAGE_SIZE;
const hasChatbot = window.HAS_CHATBOT;
const hasPollingLocator = window.HAS_POLLING_LOCATOR;
const recaptchaSiteKey = window.RECAPTCHA_SITE_KEY;
const enableAnalytics = window.ENABLE_ANALYTICS;

// Normalize BASE_URL:
// 1. Remove any trailing slashes.
// 2. This ensures that when we append '/api/', we don't get double slashes.
const normalizedBaseUrl = rawBaseUrl?.endsWith('/')
  ? rawBaseUrl.slice(0, -1) // Remove trailing slash
  : rawBaseUrl;

const appConfig = {
  APP_ENV: envConfig.VITE_APP_ENV,
  APP_NAME: envConfig.VITE_APP_TITLE,
  APP_TIMEOUT: envConfig.VITE_APP_FETCH_TIMEOUT,
  NODE_ENV: envConfig.NODE_ENV,
  VERSION: version,
  BASE_URL: normalizedBaseUrl,
  API_URL: normalizedBaseUrl + '/api/',
  VERSION_INFO_FILENAME: envConfig.VITE_APP_VERSION_INFO_FILENAME,
  PAGE_SIZE: pageSize,
  HAS_CHATBOT: hasChatbot,
  HAS_POLLING_LOCATOR: hasPollingLocator,
  RECAPTCHA_SITE_KEY: recaptchaSiteKey,
  ENABLE_ANALYTICS: enableAnalytics,
};
export default appConfig;
